// extracted by css-extract-rspack-plugin
export default {"headerContainer":"_b0dbea28","isPdpSpacingOptimizationVariant":"_cce29179","header":"_6109144f","viewMore":"_9c6eea48","itemsContainer":"_e2b49ab1"};